module.exports = __webpack_public_path__ + "media/images/TaslerIT_Logo-Sign_blk-6dfc28d51394c53d71b870a62d1acc35.svg";